/**
 * Betreff-Bausteine an- UND abwählen (Kundenfeedback Kanzlei Polz
 * 24.10.2026, XI): „Vor allem wäre es gut, wenn man die anwählen und auch
 * abwählen könnte. Momentan kann ich es nur anwählen."
 *
 * Ein Baustein gilt als gewählt, solange sein Wert im Betreff steht – auch
 * wenn er von Hand eingetippt oder über die Vorbelegung („[0/26] Testakte“)
 * hineingekommen ist. Abwählen entfernt den Wert samt Trennzeichen, ohne den
 * übrigen Betreff anzutasten.
 */

/** Trennzeichen zwischen angehängten Bausteinen (wie bisher). */
export const SUBJECT_SEPARATOR = ', '

function clean (value: string | null | undefined): string {
  return String(value ?? '').trim()
}

/** Steht der Baustein-Wert bereits im Betreff? */
export function subjectHasPart (subject: string | null | undefined, value: string | null | undefined): boolean {
  const v = clean(value)
  return v !== '' && clean(subject).includes(v)
}

/** Baustein anhängen (mit Trennzeichen, ohne Dopplung). */
export function addSubjectPart (subject: string | null | undefined, value: string | null | undefined): string {
  const cur = clean(subject)
  const v = clean(value)
  if (!v || cur.includes(v)) {
    return cur
  }
  return cur ? `${cur}${SUBJECT_SEPARATOR}${v}` : v
}

/**
 * Baustein entfernen. Ist er ein eigener, mit Komma getrennter Teil, fällt
 * genau dieser Teil weg; sonst wird das erste Vorkommen herausgelöst und
 * zurückbleibende leere Klammern bzw. doppelte Trennzeichen aufgeräumt.
 */
export function removeSubjectPart (subject: string | null | undefined, value: string | null | undefined): string {
  const cur = clean(subject)
  const v = clean(value)
  if (!v || !cur.includes(v)) {
    return cur
  }

  const parts = cur.split(',').map(p => p.trim())
  if (parts.includes(v)) {
    return parts.filter(p => p !== v && p !== '').join(SUBJECT_SEPARATOR)
  }

  const idx = cur.indexOf(v)
  const rest = cur.slice(0, idx) + cur.slice(idx + v.length)
  return rest
    .replace(/\[\s*\]|\(\s*\)/g, '')
    .replace(/\s*,\s*(,\s*)+/g, SUBJECT_SEPARATOR)
    .replace(/\s{2,}/g, ' ')
    .replace(/^[\s,–-]+|[\s,–-]+$/g, '')
    .trim()
}

/** An- bzw. abwählen je nach aktuellem Stand. */
export function toggleSubjectPart (subject: string | null | undefined, value: string | null | undefined): string {
  return subjectHasPart(subject, value) ? removeSubjectPart(subject, value) : addSubjectPart(subject, value)
}
